module.exports = __webpack_public_path__ + "svg/new-amex-small.cea4d34fe15cd9db63fbb47221ef282d.svg";